import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { Form, Button, Alert, Spinner } from "react-bootstrap";
import { GetUserInfo } from "../../../utils/permissionChecker";
import { formatDate } from "../../../utils/date_utils";
import {
  unassigned_managers,
  updateBranchManager,
} from "../../../services/employeeApi";
import { toast } from "react-toastify";
const ChangeBranchManager = ({ parentID, onSubmitButton }) => {
  const { t } = useTranslation();
  const user = GetUserInfo();
  const currentUser =
    user.employee.first_name + " " + user.employee.father_name;
  const [formerror, setFormError] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formData, setFormData] = useState({
    id: parentID.id,
    manager_id: "",
    status: 1,
    updated_by: currentUser,
  });
  const queryClient = useQueryClient();
  const UpdateManagerMutation = useMutation(async (data) => {
    await updateBranchManager(data);
    queryClient.invalidateQueries("branch");
  });
  const manager_query = useQuery(["manager"], () => unassigned_managers());
  if (manager_query.isLoading) {
    return <div>Loading...</div>;
  }
  if (manager_query.isError) {
    return <div>Error: {manager_query.error.message}</div>;
  }
  const managerData = manager_query.data;
  const UpdateManager = async (Data) => {
    try {
      setIsSubmitting(true);
      await UpdateManagerMutation.mutateAsync(Data);
      toast.success("Manager Assigned Successfully", {
        position: "top-right",
        autoClose: 4000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      handleCloseModal();
    } catch (error) {
      toast.error(error.message, {
        position: "top-right",
        autoClose: 6000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const requiredFields = ["manager_id", "id"];
    const isEmptyField = requiredFields.some((field) => !formData[field]);
    if (isEmptyField) {
      setFormError(true);
      return;
    }
    UpdateManager(formData);
  };

  const handleCloseModal = () => {
    onSubmitButton();
  };

  const handleInputChange = (e, fieldName) => {
    const { value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [fieldName]: value,
    }));
  };

  return (
    <>
      <Form onSubmit={handleSubmit}>
        {formerror ? (
          <Alert variant="danger">
            <p>Please tray again all fields are required.</p>{" "}
          </Alert>
        ) : (
          ""
        )}
        <div>
          <Form.Label
            htmlFor="inputReason"
            className="font-weight-bold text-muted"
          >
            Branch :&nbsp; {parentID.name}
          </Form.Label>
          <br></br>
          <Form.Label
            htmlFor="inputReason"
            className="font-weight-bold text-muted"
          >
            Phone :&nbsp; {parentID.phone}
          </Form.Label>
          <br></br>
          <Form.Label
            htmlFor="inputReason"
            className="font-weight-bold text-muted"
          >
            Opening Date : &nbsp; {formatDate(parentID.opening_date)}
          </Form.Label>
          <br></br>
          <Form.Label
            htmlFor="inputReason"
            className="font-weight-bold text-muted"
          >
            Manager : &nbsp; {parentID.manager?.first_namename}{" "}
            {parentID.manager?.father_namename}
          </Form.Label>
        </div>
        <Form.Group>
          <Form.Label
            htmlFor="inputReason"
            className="font-weight-bold text-muted"
          >
            {t("select_branch_manager")}
          </Form.Label>
          <select
            id="inputReason"
            className="form-select form-control choicesjs"
            value={formData.manager_id}
            onChange={(e) => handleInputChange(e, "manager_id")}
          >
            <option value="" hidden disabled>
              Select Manager
            </option>
            {managerData &&
              managerData.map((data) => (
                <option key={data.id} value={data.id}>
                  {data.first_name} {data.father_name}
                </option>
              ))}
          </select>
        </Form.Group>
        <div className="d-flex mt-1">
          <div className="mb-1">
            <Button className="btn btn-secondary" onClick={handleCloseModal}>
              {t("cancel")}
            </Button>
          </div>
          <div className="col-md-6 mb-1">
            <Button
              className="btn btn-info"
              type="submit"
              disabled={isSubmitting}
            >
              {isSubmitting ? (
                <span>
                  <Spinner
                    as="span"
                    animation="grow"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                  <span className="visually-hidden">Sending...</span>
                </span>
              ) : (
                t("change")
              )}
            </Button>
          </div>
        </div>
      </Form>
    </>
  );
};

export default ChangeBranchManager;
